import { StateKey } from 'common/utils/flipState'
import { RecommendReviewParam } from 'common/types/params'
import { fetchRecommendReviews } from 'common/services/recommendReview'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { RecommendReviewState } from 'common/types/entities/recommendReview'

const FETCH = 'review/recommendReview/FETCH'
const STACKED_FETCH = 'review/recommendReview/STACKED_FETCH'

const initialState: RecommendReviewState = {
  reviews: [],
  hasMore: false,
  cacheParam: null,
  page: 1,
}

export const fetchPagedRecommendReviews = (curState: StateKey, params: RecommendReviewParam) => async (
  dispatch,
  getState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchPagedRecommendReviews', { curState, params })
  if (isCacheHit(getState().recommendReview[curState], cacheParam)) {
    return
  }

  const reviewState = await fetchRecommendReviews(params)

  dispatch({
    curState,
    state: { ...reviewState, page: params.page },
    type: FETCH,
  })
}

export const fetchStackedRecommendReviews = (curState: StateKey, params: RecommendReviewParam) => async (
  dispatch,
  getState,
) => {
  const cacheParam = createCacheParam(STACKED_FETCH, 'fetchStackedRecommendReviews', { curState, params })
  if (isCacheHit(getState().recommendReview[curState], cacheParam)) {
    return
  }

  const fetchReviews = await fetchRecommendReviews(params)
  const reviewsState = getState().recommendReview[curState]

  const reviews = params.page === 1 ? fetchReviews.reviews : [...reviewsState.reviews, ...fetchReviews.reviews]

  dispatch({
    curState,
    cacheParam,
    state: {
      reviews,
      page: params.page,
      hasMore: fetchReviews.hasMore,
    },
    type: STACKED_FETCH,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
    case STACKED_FETCH:
      return {
        ...action.state,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}
export default reducer
